import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { getCustomButtonStyles } from '../../components/payment-checkout/payment-methods/payment-methods.utils'

export const PaymentRouterContainer = styled.div`
  width: 460px;
  margin: auto;
  margin-top: 38px;
`

export const dynamicStyle = (displayValue: string) => css`
  .yuno-status .yuno-status__button {
    display: ${displayValue};
  }
`

export const getButtonStyles = (styles: string | null) => {
  return css`
    ${getCustomButtonStyles(styles)}
  `
}
